var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5858 0C10.851 0 11.1054 0.105357 11.2929 0.292893L14.7071 3.70711C14.8946 3.89464 15 4.149 15 4.41421V12.5C15 12.7761 14.7761 13 14.5 13H10V15.5C10 15.7761 9.77614 16 9.5 16H0.5C0.223858 16 0 15.7761 0 15.5V3.5C0 3.22386 0.223858 3 0.5 3H5V0.5C5 0.223858 5.22386 0 5.5 0H10.5858ZM5 4H1V15H9V8H6C5.48716 8 5.06449 7.61396 5.00673 7.11662L5 7V4ZM10 1H6L6.00109 3.09032C6.10866 3.13942 6.20767 3.20767 6.29289 3.29289L9.70711 6.70711C9.89464 6.89464 10 7.149 10 7.41421V12H14V5H11C10.4872 5 10.0645 4.61396 10.0067 4.11662L10 4V1ZM8.586 7L6 4.415V7H8.586ZM11 1.415V4H13.586L11 1.415Z",
    fill: "#007CB0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.d7df388e8b7f7a1003a1da1fbe493d67.svg";
export { ForwardRef as ReactComponent };